import { HeartHandshake } from "lucide-react";
import { getVisits } from "@/lib/api";
import { formatSmartDate } from "@/lib/date";

const visitsProvider = {
  id: "visitas",
  label: "Visitas",
  icon: HeartHandshake,
  iconBg: "bg-emerald-50",
  iconColor: "text-emerald-600",
  fields: ["contact_name", "notes", "status"],
  load: (districtId) => getVisits({ district_id: districtId }),
  buildItem: (v) => ({
    id: v.id,
    title: v.contact_name,
    subtitle: formatSmartDate(v.date || v.visit_date),
    route: `/visits/${v.id}`,
    recent: null,
  }),
};

export default visitsProvider;
